import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';

import { useAuthContext } from 'contexts/AuthContext';

function AppGuard(props: any) {
  const { children } = props;

  const { auth } = useAuthContext();
  const location = useLocation();

  if (!auth?.token) {
    const redirectPath = `${location.pathname}${location.search}${location.hash}`;
    return (
      <Redirect
        to={`/connexion?redirect=${encodeURIComponent(redirectPath)}`}
      />
    );
  }

  return children;
}

export default AppGuard;
